// extracted by mini-css-extract-plugin
export default {"description":"style_description__zc2uF","fade-in":"style_fade-in__U-TSs","top":"style_top__xl-rG","image":"style_image__dYCB7"};